module.exports = __webpack_public_path__ + "img/border_Ring2_UP.9d1553f2.svg";